import * as XLSX from "xlsx";

/**
 * Generate Excel From Array Objects
 * @param {Array} data 
 * @param {String | null} name_book 
 * @param {String} name_file 
 */
export const exportExcelFileFromArrayObjects = (data, name_book = "Libro 1", name_file) => {
    const worksheet = XLSX.utils.json_to_sheet(data,  {raw: false});
    const columnIndexes = {
      "Fecha Factura": Object.keys(data[0]).indexOf("Fecha Factura") + 1,
      "Fecha Vencimiento": Object.keys(data[0]).indexOf("Fecha Vencimiento") + 1,
      "Monto Total": Object.keys(data[0]).indexOf("Monto Total") + 1,
    };

    data.forEach((_, index) => {
      const rowNumber = index + 2; // Empieza desde la segunda fila (saltando el encabezado)
      for (const columnName in columnIndexes) {
        const cellAddress = `${String.fromCharCode(64 + columnIndexes[columnName])}${rowNumber}`;
        if (columnName === "Fecha Factura" || columnName === "Fecha Vencimiento") {
          worksheet[cellAddress].t = "n"; // Aplicar formato de fecha DD-MM-YYYY
          worksheet[cellAddress].z = "dd-mm-yyyy"; // Aplicar formato de fecha DD-MM-YYYY
        }
        //Aplica el caso del monto
        if (columnName === "Monto Total") {
          worksheet[cellAddress].t = "n"; // Indicar que es un valor numérico (fecha)
          worksheet[cellAddress].z = "$#,##0"; // Aplicar formato de fecha DD-MM-YYYY
        }
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, name_book);
    return XLSX.writeFile(
      workbook,
      name_file
    );
}